import { AxiosRequestConfig } from "axios";
import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { toSlug } from "../../../shared/utils";
import { ContasAPagarFormData } from "../schema/criar-contas-a-pagar.schema";
import { EditarContasAPagarFormData } from "../schema/editar-contas-a-pagar.schema";
import { LiquidarContasApagarFormData } from "../schema/liquidar-conta-a-pagar.schema";
import { ResumoMes } from "../listagem-contas-a-pagar";

type ResumoItem = { sum: number; qty: number };
type SumResponse = Partial<{
    pending: ResumoItem;
    paid: ResumoItem;
    open: ResumoItem;
    closed: ResumoItem;
    anticipated: ResumoItem;
    canceled: ResumoItem;
}>;


const criar = async (data: ContasAPagarFormData, config?: AxiosRequestConfig<any> | undefined): Promise<void> => {
    try {
        const response = await baseApiService.post('/accounts-payable', data, config);
        return response.data.data.id;
    } catch (err) {
        throw errosHandler(err);
    }
};

const deletar = async (id: string): Promise<string> => {
    try {
        const response = await baseApiService.delete(`/accounts-payable/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/accounts-payable/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const editar = async (id: string, data: EditarContasAPagarFormData): Promise<void> => {
    try {
        await baseApiService.put(`/accounts-payable/${id}`, data);
    }
    catch (err) {
        throw errosHandler(err);
    }
};

const liquidar = async (id: string, data: LiquidarContasApagarFormData): Promise<void> => {
    try {
        await baseApiService.post(`/accounts-payable/liquidate/${id}`, data);
    }
    catch (err) {
        throw errosHandler(err);
    }
};

const findAll = async (filtro?: string, pagina = 0, limite = 10, campo?: string): Promise<{ items: any[]; totalItems: number }> => {
    try {
        const filtroPesquisa = filtro?.trim() ? toSlug(filtro) : "";
        const query = filtroPesquisa
            ? `/accounts-payable?page=${pagina + 1}&limit=${limite}&campo_pesquisa=slug&tipo_pesquisa=in&valor_pesquisa=${filtro}`
            : `/accounts-payable?page=${pagina + 1}&limit=${limite}`;
        const result = await baseApiService.get(query);
        const responseData = result.data?.data;
        return {
            items: Array.isArray(responseData?.items) ? responseData.items : [],
            totalItems: responseData?.meta?.totalItems || 0,
        };
    } catch (error) {
        console.error("Erro ao buscar empresas:", error);
        throw errosHandler(error);
    }
};


const sum = async (filtro?: string): Promise<SumResponse> => {
    try {
        const base = `/accounts-payable/sum`;
        const query = filtro?.trim() ? `${base}?${filtro}` : base;
        const result = await baseApiService.get(query);
        const responseData = result.data?.data as SumResponse | undefined;
        return responseData ?? {};
    } catch (error) {
        console.error("Erro ao buscar resumo:", error);
        throw errosHandler(error);
    }
};


export const contasAPagarService = {
    criar,
    deletar,
    detalhar,
    editar,
    findAll,
    liquidar,
    sum,
};

